<template>
  <card-order-review-data
    class="card-order-update-modal"
    heading="Please, check all information again and confirm card order update"
    :card-order="updatedCardOrder"
    :card-order-profile="cardOrderProfile"
  >
    <template v-if="cardOrder.isRealCardType">
      <one-data-column :label-props="{ style: 'display: none;' }">
        <data-divider />
      </one-data-column>

      <one-data-column>
        <data-label
          slot="label"
          highlight
        >Expences</data-label>
      </one-data-column>

      <one-data-column>
        <data-label slot="label">Fee account</data-label>
        <div class="t-review-fee-account">{{ updatedCardOrder.feeAccountId }}</div>
      </one-data-column>

      <one-data-column>
        <data-label slot="label">Fee currency</data-label>
        <div class="t-review-fee-currency">{{ updatedCardOrder.feeCurrency }}</div>
      </one-data-column>

      <one-data-column>
        <data-label slot="label">Delivery fee</data-label>
        <div class="t-review-delivery-fee">{{ deliveryFee | number }} {{ updatedCardOrder.feeCurrency }}</div>
      </one-data-column>
    </template>

    <template slot="actions">
      <v-btn
        class="t-update-order"
        color="primary"
        flat="flat"
        :disabled="updateCardOrderApiRequest.loading"
        @click="onUpdateButtonClick"
      >update card order</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        flat="flat"
        @click="closeModal"
      >cancel</v-btn>
    </template>
  </card-order-review-data>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { createCardOrderViewRoute } from '@/utils/routing/Issuing'

  // Events
  import { EVENT_CARD_ORDER_UPDATE } from '@/events/cardOrders'

  // Models
  import CardOrder from '@/models/CardOrder'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Components
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import DataDivider from '@/components/ui/Data/DataDivider'
  import CardOrderReviewData from '@/components/cards/CardOrderReviewData'

  export default {
    name: 'CardOrderUpdateModal',
    components: {
      OneDataColumn,
      DataLabel,
      DataDivider,
      CardOrderReviewData
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cardOrder () {
        return this.modal.data.cardOrder
      },
      cardOrderProfile () {
        return this.modal.data.cardOrderProfile
      },
      formData () {
        return this.modal.data.formData
      },
      deliveryFee () {
        return this.modal.data.deliveryFee
      },
      updatedCardOrder () {
        return new CardOrder({ ...this.cardOrder, ...this.formData })
      },
      updateCardOrderApiRequest () {
        return new ApiRequest(this.cardOrder.isInitializedRenew ? IssuingApi.updateRenewalCardOrder : IssuingApi.updateCardOrder)
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      createCardOrderViewRoute,
      onUpdateButtonClick () {
        this.updateCardOrderApiRequest
          .execute(this.cardOrder.id, {
            ...this.formData,
            holderType: this.cardOrder.holderType // Required for backend
          })
          .then(this.onCardOrderUpdateSuccess)
          .catch(this.onCardOrderUpdateError)
      },
      onCardOrderUpdateSuccess () {
        this.showModal({
          name: 'SuccessFlashModal',
          data: {
            redirectPath: createCardOrderViewRoute(this.cardOrder.id),
            message: 'Card order has been successfully updated.'
          }
        })
      },
      onCardOrderUpdateError (error) {
        this.$eventHub.$emit(EVENT_CARD_ORDER_UPDATE, error)

        this.showModal({
          name: 'ErrorFlashModal',
          data: {
            message: 'Card order has not been updated.'
          }
        })
      }
    }
  }
</script>
